// ─────────────────────────────────────────────────────────────────────────
// articleImages.js — per-article photography manifest + lookup helper
//
// Images are sourced from Pixabay (royalty-free, no attribution legally
// required, but we credit the photographer as good practice), curated one
// per article to match the topic, optimized to WebP at two sizes:
//   • hero  — 1200px wide, rendered full-column-width on ArticlePage
//   • thumb — 480px wide, rendered on index/listing cards
//
// Files live in /public/images/articles/<slug>.webp and <slug>-thumb.webp,
// so they're served as static assets straight from the site root and can be
// referenced by absolute path (no import/bundling needed).
//
// The manifest itself (slug → { hero, thumb, alt, credit, creditUrl, source })
// is generated and stored in article-images.json next to this file.
// ─────────────────────────────────────────────────────────────────────────

import images from './article-images.json';

// Look up the image record for an article slug. Returns null when an article
// has no curated image, so callers can render their existing (image-less)
// layout unchanged.
export function getArticleImage(slug) {
  if (!slug) return null;
  return images[slug] || null;
}

export default images;
